import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ProposalContactLog/";

const GetProposalContactLogs = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalContactLogs?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS);

const SaveProposalContactLog = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProposalContactLog', model, constants.REQUIRE_INTERCEPTORS);

export {
    GetProposalContactLogs,
    SaveProposalContactLog,
}